// GA4 ผ่าน GTM (GTM-N9ZKLKC) — ส่งแบบเดียวกับ event อื่นในโปรเจกต์: window.dataLayer.push({ event, ...params })
// GTM ต้องมี GA4 Event tag + trigger ของแต่ละ event จึงจะถึง GA4 (ดู scripts/bigc-exhibition/GA4_TRACKING.md)
// ไม่ส่งข้อมูลส่วนบุคคล (LINE userId ฯลฯ) — ส่งเฉพาะข้อมูลถุงและการกระทำบนหน้า

// GTM จำค่าใน dataLayer ข้าม event — ล้างทุก key ที่ไม่ได้ส่ง เพื่อไม่ให้ค่าของ event ก่อนหน้าติดไปกับ event ถัดไป
const PARAM_KEYS = [
  "bag_id", "province_th", "province_en", "region", "edition", "source", "method", "view", "from",
  "hotspot_id", "hotspot_title", "hotspot_category", "visible", "search_term", "has_bag", "list", "from_province",
];

// ภาษาที่ผู้ชมใช้อยู่ (?lang=en หรือค่าที่จำไว้) แนบไปกับทุก event
const currentLang = () => {
  try {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q === "en" || q === "th") return q;
    return window.localStorage.getItem("bce_lang") === "en" ? "en" : "th";
  } catch (e) {
    return "th";
  }
};
const CLEARED = Object.fromEntries(PARAM_KEYS.map((k) => [k, undefined]));

export const track = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...CLEARED, lang: currentLang(), ...params });
  } catch (e) {
    // analytics ต้องไม่ทำให้หน้าใช้งานไม่ได้
  }
};

export const bagParams = (c) => ({
  bag_id: c.id,
  province_th: c.provinceTh,
  province_en: c.provinceEn,
  region: c.region,
  edition: c.editionEn || "",
});
